var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agree"},[_c('p',{staticClass:"blick-tit",on:{"click":_vm.goBack}},[_vm._v("返回")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agree-con"},[_c('h6',[_vm._v("用户服务协议")]),_c('div',{staticClass:"agreeTxt",attrs:{"id":"serviceInfo"}})])
}]

export { render, staticRenderFns }